import { JstType } from '../../models/jobModels/jstType';
import { InputFile } from '../../models/jobModels/ModelsFileTypes';
import { JstNumerical, JstSubmission, SimsFiles } from '../../models/inputTypes/JstFields';
import {
  jstNumericalInitialState,
  jstSubmissionInitialState,
  simsFileslInitialObject,
} from '../initialStates/jstInitialStates';

export type JstSimulationPreparationResponse = {
  numeric: JstNumerical;
  submission: JstSubmission;
};

const prepareInputSimsFiles = (inputFiles: Partial<InputFile>[]): SimsFiles[] => {
  return inputFiles.map((file, i) => {
    const currentFile = {
      currentFile: { project: +(file.project ?? ''), name: file.fileid },
      fileName: file.fileid ?? '',
    };
    return { file: currentFile };
  });
};

export const jstSimulationPreparation = (simulationFile: JstType): JstSimulationPreparationResponse | undefined => {
  // const outputFile = simulationFile.parameters.output_file[0];
  const preparedSimsFiles = prepareInputSimsFiles(simulationFile.parameters.input_file);

  const numeric: JstNumerical = {
    project: simulationFile.project ? simulationFile.project.toString() : jstNumericalInitialState.project,
    simulationSetup: undefined,
    simsFiles: preparedSimsFiles?.length ? preparedSimsFiles : [simsFileslInitialObject],
  };

  const submission: JstSubmission = {
    simulationFile: jstSubmissionInitialState.simulationFile,
  };
  return { numeric, submission };
};
